import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";

const PlVehicleServiceHistory = React.forwardRef((props, ref) => {
  const serviceInfoInitialData = {
    serviceId: "",
    serviceDate: "",
    serviceCenter: "",
    serviceType: "",
    odometerReading: "",
    issuesReported: "",
    workPerformed: "",
    partsReplaced: "",
    totalCost: "",
    nextServiceDue: "",
    invoiceNumber: "",
    remarks: "",
  };

  const [serviceDetails, setServiceDetails] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  useEffect(() => {
    if (props?.getServiceData) {
      setServiceDetails(props?.getServiceData);
    } else {
      setServiceDetails([]);
    }
  }, [props]);

  const handleSubmit = async () => {
    const finalData = {
      serviceHistory: serviceDetails,
    };

    if (props?.onSave) {
      props.onSave(finalData);
    }
    props?.onHide();
  };

  // Service Info Section
  // const addServiceForm = () => {
  //   setServiceDetails([...serviceDetails, { ...serviceInfoInitialData }]);
  // };
  const addServiceForm = () => {
    const newServiceId = `SERVICE-${serviceDetails.length + 1}`; // auto-generate ID
    const newServihcleID = parseFloat(serviceDetails.length + 1);

    setServiceDetails([
      ...serviceDetails,
      {
        ...serviceInfoInitialData,
        serviceId: newServiceId,
        serviceVehicleId: newServihcleID,
        serviceCreated: true,
      },
    ]);
  };

  // const removeServiceForm = (indexToRemove) => {
  //   setServiceDetails(
  //     serviceDetails.filter((form, index) => index !== indexToRemove)
  //   );
  // };

  const removeServiceForm = (serviceIdToRemove) => {
    setServiceDetails((prevDetails) =>
      prevDetails.filter((form) => form.serviceId !== serviceIdToRemove),
    );
  };

  // const handleChangeServiceInfo = (index, key, value) => {
  //   const newForms = [...serviceDetails];
  //   newForms[index][key] = value;
  //   setServiceDetails(newForms);
  // };

  //   const handleChangeServiceInfo = (index, key, value) => {
  //   setServiceDetails((prev) => {
  //     const updated = [...prev];

  //     // If object doesn't exist at index, create one
  //     if (!updated[index]) {
  //       updated[index] = {};
  //     }

  //     updated[index] = {
  //       ...updated[index],
  //       [key]: value,
  //     };

  //     return updated;
  //   });
  // };

  const handleChangeServiceInfo = (serviceVehicleId, key, value) => {
    setServiceDetails((prev) =>
      prev.map((item) =>
        item.serviceVehicleId === serviceVehicleId
          ? { ...item, [key]: value }
          : item,
      ),
    );
  };

  useEffect(() => {
    // Initialize with one service form
    if (serviceDetails?.length === 0) {
      addServiceForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //table service history
  const serviceHistoryColumn = [
    {
      name: "Service ID",
      selector: (row) => row?.serviceId || "--",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status">
          {row.serviceId}
        </span>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Service Date",
      selector: (row) => row?.serviceDate || "--",
      cell: (row) => <p className="m-0 p-0 pt-1 fw-bold">{row.serviceDate}</p>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Service Center",
      selector: (row) => row?.serviceCenter || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Service Type",
      selector: (row) => row?.serviceType || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Odometer Reading",
      selector: (row) => row?.odometerReading || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Issues Reported",
      selector: (row) => row?.issuesReported || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Work Performed",
      selector: (row) => row?.workPerformed || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Parts Replaced",
      selector: (row) => row?.partsReplaced || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Total Cost",
      selector: (row) => row?.totalCost || "--",
      cell: (row) => <p className="m-0 p-0 fw-bold">{row.totalCost}</p>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Next Service Due",
      selector: (row) => row?.nextServiceDue || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 text-primary fw-bold">
          {row.nextServiceDue}
        </p>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Invoice Number",
      selector: (row) => row?.invoiceNumber || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Remarks",
      selector: (row) => row?.remarks || "--",
      sortable: true,
      width: "200px",
    },
  ];

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Services</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="py-2">
          {!props?.editMode && (
            <Col
              xs={{ span: 2, offset: 10 }}
              md={{ span: 2, offset: 10 }}
              lg={{ span: 2, offset: 10 }}
            >
              <button className="btnTable" onClick={() => addServiceForm()}>
                <i className="bi bi-plus-lg"></i> Add Service
              </button>
            </Col>
          )}
        </Row>

        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">SI</span>
                </Col>
                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Service Information</span>
                  <span className="subHeaderTitle">Service</span>
                </Col>
              </Row>
            </h2>

            {/* Service Information */}
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                {/* To Load Dynamic Service Info Form */}

                {serviceDetails && serviceDetails?.length > 0 ? (
                  <>
                    {serviceDetails
                      ?.filter((item) => item?.serviceCreated === true)
                      ?.slice() 
                      ?.reverse() 
                      ?.map((item) => (
                        <div key={item?.serviceVehicleId}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Service {item?.serviceVehicleId}</h6>
                              {!props?.editMode && (
                                <span
                                  className="deleteIconAccordion"
                                  onClick={() =>
                                    removeServiceForm(item?.serviceId)
                                  }
                                >
                                  <i className="bi bi-x-circle"></i>
                                </span>
                              )}
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Service Id"
                                name="serviceId"
                                placeholder=""
                                value={item?.serviceId}
                                disabled={true}
                                // onChange={(e) =>
                                //   handleChangeServiceInfo(
                                //     index,
                                //     "serviceId",
                                //     e.target.value
                                //   )
                                // }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Vehicle Number"
                                name="vehicleNumber"
                                placeholder=""
                                value={props?.vehicleRegistrationNr}
                                // onChange={(e) => handleChangeServiceInfo(index, "vehicleNumber", e.target.value)}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Service Date"
                                name="serviceDate"
                                placeholder=""
                                value={item?.serviceDate || ""}
                                disabled={props?.editMode}
                                min={2000}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "serviceDate",
                                    e.target.value,
                                  )
                                }
                                type="date"
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Service Center"
                                name="serviceCenter"
                                placeholder=""
                                value={item?.serviceCenter}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "serviceCenter",
                                    e.target.value,
                                  )
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Service Type"
                                name="serviceType"
                                placeholder=""
                                value={item?.serviceType}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "serviceType",
                                    e.target.value,
                                  )
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Odometer Reading"
                                name="odometerReading"
                                placeholder=""
                                value={item?.odometerReading}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "odometerReading",
                                    e.target.value,
                                  )
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Issues Reported"
                                name="issuesReported"
                                placeholder=""
                                value={item?.issuesReported}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "issuesReported",
                                    e.target.value,
                                  )
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Work Performed"
                                name="workPerformed"
                                placeholder=""
                                value={item?.workPerformed}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "workPerformed",
                                    e.target.value,
                                  )
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Parts Replaced"
                                name="partsReplaced"
                                placeholder=""
                                value={item?.partsReplaced}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "partsReplaced",
                                    e.target.value,
                                  )
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Cost"
                                name="totalCost"
                                placeholder=""
                                value={item?.totalCost}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "totalCost",
                                    e.target.value,
                                  )
                                }
                                type="number"
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Next Service Due"
                                name="nextServiceDue"
                                placeholder=""
                                value={item?.nextServiceDue}
                                disabled={props?.editMode}
                                min={2000}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "nextServiceDue",
                                    e.target.value,
                                  )
                                }
                                type="date"
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Number"
                                name="invoiceNumber"
                                placeholder=""
                                value={item?.invoiceNumber}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "invoiceNumber",
                                    e.target.value,
                                  )
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Remarks"
                                zz
                                name="remarks"
                                placeholder=""
                                value={item?.remarks}
                                disabled={props?.editMode}
                                onChange={(e) =>
                                  handleChangeServiceInfo(
                                    item?.serviceVehicleId,
                                    "remarks",
                                    e.target.value,
                                  )
                                }
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </>
                ) : (
                  <p className="d-flex justify-content-center py-2 my-4">
                    {" "}
                    Service not created
                  </p>
                )}
              </div>
            </div>
            {/* table */}

            <div className="accordion my-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SH</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Service History</span>
                      <span className="subHeaderTitle">
                        Service History Details{" "}
                      </span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                                                  <POCollabrationCommonFillter />
                                                </Col> */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={serviceHistoryColumn}
                          data={serviceDetails}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={
                          //   Constants.ROW_PER_PAGE
                          // }
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      {!props?.editMode && (
        <Modal.Footer>
          <button onClick={handleSubmit} className="btn btn-primary">
            Submit
          </button>
          <button onClick={props?.onHide} className="btn btn-danger">
            Cancel
          </button>
        </Modal.Footer>
      )}
    </Modal>
  );
});

export default PlVehicleServiceHistory;
